
import { CSSProperties } from "@mui/material/styles/createTypography"
import { IdentityClient } from "api-clients/IdentityClient"
import { PlansClient } from "api-clients/PlansClient"
import { LogoType, ProductInfoService } from "services/ProductInfoService"
import Container from "components/layout/Container"
import Grid from 'components/layout/grid/Grid'
import Item from 'components/layout/grid/Item'
// import './home.scss';
import Title from "components/labels/Title"
import Subtitle from "components/labels/SubHeading"
import Page from "components/layout/Page"
import Section from "components/layout/Section"
import Button from "components/buttons/Button"
import Box from "components/layout/box/Box"
import Heading from "components/labels/Heading"
import Text from 'components/labels/Text';

import CardFeature from 'views/home/CardFeature'
import { ColorsUtil, MyTheme } from "MyTheme"
import { Avatar, Card, CardActions, CardContent, CardHeader, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Stack, Step, StepButton, StepLabel, Stepper, useMediaQuery, Zoom } from "@mui/material"
import React, { useEffect, useRef, useState, VideoHTMLAttributes } from "react"
import useVisibility from "hooks/UseVisibility"
import Animation from "components/animations/Animation"
import SubHeading from "components/labels/SubHeading"
import TitleBlock from "components/layout/TitleBlock"
import Icon from "components/icons/Icon"
import { VideoMarker, VideoMarkersController } from "utils/VideoUtil"
import Modal from "components/modals/Dialog"
import Dialog from "components/modals/Dialog"
import { Plan } from "models/Plan"
import { Price } from "models/Price"
import FieldCollection from "components/fields/fieldCollection/FieldCollection"
import TextField from "components/fields/textField/TextField"
import { Link as NavLink, useNavigate } from 'react-router-dom';
import { UserService } from "services/UserService"
import Form from "components/forms/Form"
import { Bootstrapper } from "Bootstrapper"
import Link from "components/buttons/Link"
import LoadingButton from "components/buttons/LoadingButton"




const LoginForm = (props: any) => {
    const {simple, onSubmit, onRegister, onForgotPassword, ...rest} = props;
    const navigate = useNavigate();
    const userService = new UserService();
    const theme = MyTheme();
    const bg1 = theme.palette.grey[200];
    const bg2 = theme.palette.grey['100'];
    

    const [validationMsg, setValidationMsg] = useState<string>("");
    const [canSubmit, setCanSubmit] = useState<boolean>(true);
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const prodInfoService = Bootstrapper.getInstance<ProductInfoService>(ProductInfoService);

    const onSubmitAsync = async() => {
        setValidationMsg("");
        setCanSubmit(false);

        var result = await userService.loginAsync(email, password).catch((err: Error) => {
            setValidationMsg(err.message || "The email or password is incorrect");
        });

        onSubmit(result);
        
        // if(result && redirect)
        //     navigate(redirect);
        
        setCanSubmit(true);
    }

    const logoUrl = prodInfoService.getLogoUrl(LogoType.WithTextTransparent);
    const homeIcon = <Box mb={0} display='flex' alignItems='center' width={'250px'}><img alt="Zibbit logo" src={logoUrl}/></Box>
    const titleWrapper = <Box p={0} mb={0}  display='flex' flexDirection='column' alignItems='center' justifyContent='left'>
                            <SubHeading component="h1" textAlign='center'>Login</SubHeading>
                            <Text mt={0} variant="caption">Don't have an account? <Link onClick={onRegister} component={NavLink} variant="text" to={'/register'}>Register</Link></Text>
                            <Box mt={4} mb={4}>
                                {homeIcon}
                            </Box>

                        </Box>
    return(
                    <Box>                        
                        <Form 
                        flat={simple}
                        validationMsg={validationMsg}
                        action={<LoadingButton loading={!canSubmit} disabled={!canSubmit} onClick={() => onSubmitAsync()} fullWidth>Submit</LoadingButton>}
                        title={simple ? null : titleWrapper}
                        >
                            <FieldCollection>
                                <TextField 
                                    name="username" id="username" value={email} onChange={(ele: any) => setEmail(ele.target.value)} label="Email" {...rest} />

                                <TextField 
                                    name="password"
                                    id="password"
                                    type="password"
                                    value={password} 
                                    onChange={(ele: any) => setPassword(ele.target.value)} 
                                    label="Password"
                                    helperText={ <Link onClick={onForgotPassword} tabIndex="-1" sx={{}} component={NavLink} to="/password-reset-link">Forgot password?</Link>}
                                    helperTextProps={{sx: {marginLeft: 0}}}
                                    {...rest}
                                    />
                                
                            </FieldCollection>
                        </Form>
                        {simple && <Text mt={1} variant="caption">Don't have an account? <Link onClick={onRegister} component={NavLink} variant="text" to={'/register'}>Register</Link></Text>}

                    </Box>

    )

}


export default LoginForm